import { App } from "core.app";

export function getApp() {
  return App;
}

export default getApp;
